import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import DropdownMC from '../../../components/DropdownMC';
import SearchComponent from '../../../components/SearchMC';
import AccordionMC from '../../../components/AccordionMC';
import TitleMC from '../../../components/TitleMC';
import { MESSAGE_TYPES } from '../../../../constants/campaignsConstants';

const Step2GupshupPartial = ({
  onSelectProp,
  templateFilters,
  setTemplateFilters,
  selectedTemplate,
  activeValidation
}) => {
  const { t } = useTranslation('createCampaign');
  const { current_retailer } = useSelector(
    (reduxState) => reduxState.createCampaignReducer
  );

  const teams = (current_retailer?.catalogs?.gupshup_teams_templates || []).map((team) => ({
    id: team.id,
    label: team.name,
    color: team.data_color
  }));

  const templates = () => {
    const templateValues = (current_retailer.templates?.templates || []);
    const filterTemplates = templateValues.filter((template) => {
      const search = (templateFilters.search || '').toLowerCase();
      const name = (template.name || '').toLowerCase();
      const text = (template.text || '').toLowerCase();
      const templateType = template.template_type;
      const teamId = template.team_id;
      const searchFilter = search ? name.includes(search) || text.includes(search) : true;
      const typeFilter = templateFilters.template_type && templateFilters.template_type !== 'all' ? templateType === templateFilters.template_type : true;
      const teamFilter = templateFilters.team_id && templateFilters.team_id !== 'all' ? teamId === templateFilters.team_id : true;
      return searchFilter && typeFilter && teamFilter;
    });
    return filterTemplates.map((template) => {
      const typeConfig = MESSAGE_TYPES.find((type) => type.value === template.template_type);
      return {
        id: template.id,
        title: template.name,
        subtitle: typeConfig ? t(typeConfig.label) : template.template_type,
        icon: typeConfig?.icon || null,
        text: template.text,
        templateType: template.template_type
      };
    });
  };

  const onChangeFilter = (field, value) => {
    setTemplateFilters({ ...templateFilters, [field]: value });
    onSelectProp('template', null);
  };

  const filteredTemplates = templates();

  return (
    <div className="tw-wrapper">
      <div id="step-2">
        <TitleMC text={t('step2Gupshup.title')} variant="BASE" />
        <div className="tw-text-body tw-pb-4">
          {t('step2Gupshup.description')}
        </div>
        <div className="tw-pb-4 tw-w-full">
          <SearchComponent
            mainContainerClassName="!tw-max-w-full"
            onChange={(value) => onChangeFilter('search', value)}
            defaultValue={templateFilters.search}
          />
        </div>
        <div className="tw-pb-4 tw-w-full">
          {/* TODO: Dropdown no está seleccionando el valor */}
          <DropdownMC
            name="team_id"
            id="team_id"
            label={t('step2Gupshup.team')}
            options={teams}
            onSelect={(value) => onChangeFilter('team_id', value)}
            defaultValue={templateFilters.team_id}
          />
        </div>
        <div className="tw-pb-4 tw-w-full">
          {/* TODO: Dropdown no está seleccionando el valor */}
          <DropdownMC
            name="template_type"
            id="type"
            label={t('step2Gupshup.type')}
            options={MESSAGE_TYPES.map((type) => ({
              id: type.value,
              label: t(type.label),
              icon: type.icon
            }))}
            onSelect={(value) => onChangeFilter('template_type', value)}
            defaultValue={templateFilters.template_type}
          />
        </div>
        <div className="tw-pb-4 tw-w-full">
          {activeValidation && !selectedTemplate?.id
           && (
           <p className="tw-text-xs tw-text-red-500">
             {t('step2Gupshup.selectTemplateError')}
           </p>
           )}
          <AccordionMC
            onToggleOpen={(openAccordion) => setTemplateFilters({ ...templateFilters, openAccordion })}
            defaultOpen
            defaultOption={selectedTemplate}
            optionId={selectedTemplate?.id || null}
            name="templatesSelect"
            id="accordion"
            label={t('step2Gupshup.templates')}
            options={filteredTemplates}
            onSelect={(optionId) => {
              const template = filteredTemplates.find((itemTemplate) => itemTemplate.id === optionId);
              if (onSelectProp) {
                onSelectProp('template', template);
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Step2GupshupPartial;
